import React, { useContext } from 'react';

import { excApi, handleApiCall } from '@exchange-frontends/api';
import { useIsMounted } from '@exchange-frontends/custom-hooks';

import { useStore } from '../../../store';
import { UserDataContext } from '../../App';
import AcquireAppButton from './AcquireAppButton';
import { HeaderButtonsContext } from './HeaderButtons';

const EcFreeAppButton = () => {
  const isMounted = useIsMounted();
  const { accessToken } = useContext(UserDataContext) ?? {};
  const { selectedOrg, setShowPluginAcquiredDialog } = useContext(HeaderButtonsContext);
  const detailScreen = useStore((state) => state.detailScreen);
  const appId = detailScreen?.id;
  const versionId = detailScreen?.appVersionId;

  const acquireFreeEnterpriseApp = async () => {
    const orgId = selectedOrg?.code;
    const handler = handleApiCall(excApi.createEnterpriseEntitlements, { orgId, appId, versionId, accessToken });
    await handler.run();
    if (isMounted.current) {
      useStore.setState({ acquired: true });
      setShowPluginAcquiredDialog(true);
    }
  };

  return <AcquireAppButton type="free" onPress={acquireFreeEnterpriseApp} />;
};

export default EcFreeAppButton;
